const STATUS_SUFFIX_KEYS = {
  on_track: 'inProgress',
  at_risk: 'inProgress',
  done: 'done',
};

const STATUS_PREFIX = {
  done: '✓ ',
  on_track: '● ',
  at_risk: '● ',
  open: '○ ',
};

function formatShortDate(value) {
  if (!value) return '';
  const date = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(date.getTime())) return '';
  return date.toLocaleDateString('de-DE', { day: '2-digit', month: '2-digit' });
}

/**
 * PDF-style milestone option: "○ Title · dd.MM. [IN ARBEIT]"
 * Completed milestones are marked disabled in the option list.
 */
export function formatMilestoneSelectLabel(milestone, translate) {
  if (!milestone) return '';
  const title = milestone.title || '—';
  const due = formatShortDate(milestone.dueDate);
  const status = milestone.status || 'open';
  const prefix = STATUS_PREFIX[status] || STATUS_PREFIX.open;
  const suffixKey = STATUS_SUFFIX_KEYS[status];
  const suffix = suffixKey
    ? ` [${translate(`UserProjects.commitmentDialog.milestoneStatus.${suffixKey}`)}]`
    : '';
  const datePart = due ? ` · ${due}` : '';
  return `${prefix}${title}${datePart}${suffix}`;
}

export function isMilestoneOptionDisabled(milestone) {
  return milestone?.status === 'done';
}

/**
 * @param {Array<{ id: string, title?: string, dueDate?: string, status?: string }>} milestones
 * @param {(key: string) => string} translate
 */
export function buildMilestoneSelectOptions(milestones, translate) {
  const noneOption = {
    label: translate('UserProjects.commitmentDialog.milestoneNone'),
    value: null,
    disabled: false,
  };

  const milestoneOptions = (milestones || []).map((milestone) => ({
    label: formatMilestoneSelectLabel(milestone, translate),
    value: milestone.id,
    disabled: isMilestoneOptionDisabled(milestone),
  }));

  return [noneOption, ...milestoneOptions];
}
